export const SchoolDataForm = {
    school: {},
    schoolClasses: {}
};
